<app-page pageTitle="Charts">
  <div class="charts-container">
    <app-labeled-container class="width-100" label="Time Charts">
      @for (item of timeCharts; track $index; let last = $last) {
      <app-category-item
        [label]="item.label"
        [icon]="item.icon"
        [value]="item.value"
        [underlined]="!last"
        (click)="navigateToChart(item.route)"
      />
      }
    </app-labeled-container>
    <app-labeled-container class="width-100" label="Day Charts">
      @for (item of dayCharts; track $index; let last = $last) {
      <app-category-item
        [label]="item.label"
        [icon]="item.icon"
        [value]="item.value"
        [underlined]="!last"
        (click)="navigateToChart(item.route)"
      />
      }
    </app-labeled-container>
  </div>
</app-page>
